import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { RichText, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    align,
    value,
    citation
  } = attributes;
  const className = classnames({
    [`has-text-align-${align}`]: align
  });
  return createElement("blockquote", useBlockProps.save({
    className
  }), createElement(RichText.Content, {
    multiline: true,
    value: value
  }), !RichText.isEmpty(citation) && createElement(RichText.Content, {
    tagName: "cite",
    value: citation
  }));
}
//# sourceMappingURL=save.js.map